import apiClient from "../../api/api";

/**
 * @description Fetches the current announcement.
 *
 * @async
 * @function requestGetAnnouncement
 * @returns {Promise<any>} A promise that resolves with the announcements data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestGetAnnouncement = async() => {
    const getAnnouncementsResponse = await apiClient.get(import.meta.env.VITE_BASE_ANNOUNCEMENT_URL)
    return getAnnouncementsResponse.data
}

/**
 * @description Fetches all announcements.
 *
 * @async
 * @function requestGetAllAnnouncements
 * @returns {Promise<any>} A promise that resolves with the announcements data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestGetAllAnnouncements = async() => {
    const response = await apiClient.get(import.meta.env.VITE_BASE_ANNOUNCEMENT_URL + "/all")
    return response.data
}

/**
 * @description Updates an existing announcement.
 *
 * @async
 * @function requestUpdateAnnouncement
 * @param {number} id - The unique identifier of the announcement.
 * @param {Object} announcement - The announcement payload to be updated.
 *
 * @returns {Promise<any>} A promise that resolves with the update response.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestUpdateAnnouncement = async(id, announcement) => {
    const updateAnnouncmenetResponse = await apiClient.put(import.meta.env.VITE_BASE_ANNOUNCEMENT_URL+`/${id}`, announcement, {successToast:"Announcement updated"})

    return updateAnnouncmenetResponse
}

/**
 * @description Create an announcement.
 *
 * @async
 * @function requestCreateAnnouncement
 * @param {Object} announcement - The announcement payload to be created.
 *
 * @returns {Promise<any>} A promise that resolves with the create response.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestCreateAnnouncement = async(announcement) => {
    const response = await apiClient.post(import.meta.env.VITE_BASE_ANNOUNCEMENT_URL, announcement, {successToast:"Announcement created"})
    return response.data
}